import Blog from "@/Layouts/Blog";
import Contact from "@/Sections/Contact";
import { Head } from "@inertiajs/inertia-react";

export default () => {
    return (
        <Blog>
            <Head>
                <title>
                    Waarom het moeite kost om gewicht te verliezen tijdens de
                    menstruatie
                </title>
                <link rel="canonical" href={route("blogs.forty-two")} />

                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1"
                />
                <meta property="og:locale" content="nl_NL" />

                <meta
                    name="description"
                    content="Als vrouw zijnde ben je vast wel bekend met de maandelijkse cyclus die gepaard gaat met menstruatie. Naast de fysieke en emotionele veranderingen die optreden, kan het ook invloed hebben op je gewichtsverliesdoelen. Veel vrouwen merken namelijk dat het moeilijker is om gewicht te verliezen tijdens hun menstruatie. Maar waarom is dit eigenlijk zo? In deze blogpost zullen we de redenen achter dit fenomeen onderzoeken."
                />
                <meta
                    property="og:description"
                    content="Als vrouw zijnde ben je vast wel bekend met de maandelijkse cyclus die gepaard gaat met menstruatie. Naast de fysieke en emotionele veranderingen die optreden, kan het ook invloed hebben op je gewichtsverliesdoelen. Veel vrouwen merken namelijk dat het moeilijker is om gewicht te verliezen tijdens hun menstruatie. Maar waarom is dit eigenlijk zo? In deze blogpost zullen we de redenen achter dit fenomeen onderzoeken."
                />
                <meta property="og:url" content={route("blogs.forty-two")} />
                <meta property="og:type" content="article" />
                <meta
                    property="og:title"
                    content="Waarom het moeite kost om gewicht te verliezen tijdens de menstruatie - WE ARE Personal Training Uden en Schijndel"
                />
                <meta
                    property="og:image"
                    content="/assets/blog/gewicht-verliezen-menstruatie.jpg"
                />
            </Head>

            <div className="bg-black">
                <div className="relative xs:h-[30vh] sm:h-[30vh] md:h-[65vh] lg:h-[65vh] pb-32">
                    <div>
                        <div className="absolute inset-0">
                            <picture>
                                <source
                                    srcSet="/assets/blog/webp/gewicht-verliezen-menstruatie.webp"
                                    type="image/webp"
                                    alt="Gewicht verliezen tijdens de menstruatie"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <source
                                    srcSet="/assets/blog/gewicht-verliezen-menstruatie.jpg"
                                    type="image/jpeg"
                                    alt="Gewicht verliezen tijdens de menstruatie"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                                <img
                                    src="/assets/blog/gewicht-verliezen-menstruatie.jpg"
                                    alt="Gewicht verliezen tijdens de menstruatie"
                                    className="xs:w-full sm:w-full md:w-full lg:w-full h-full object-cover"
                                />
                            </picture>
                            <div
                                className="absolute inset-0 bg-gray-800 opacity-50 mix-blend-multiply"
                                aria-hidden="true"
                            />
                        </div>
                    </div>
                </div>
                <div className="xs:px-8 sm:px-8 md:px-16 lg:px-16 xs:py-12 sm:py-12 md:py-24 lg:py-24 max-w-7xl mx-auto">
                    <h1 className="block text-white font-custom italic font-bold uppercase xl:inline xs:text-5xl sm:text-5xl md:text-6xl lg:text-6xl break-words">
                        Waarom het moeite kost om gewicht te verliezen tijdens
                        de menstruatie
                    </h1>
                    <p className="mt-4 text-gray-100 break-words">
                        Als vrouw zijnde ben je vast wel bekend met de
                        maandelijkse cyclus die gepaard gaat met menstruatie.
                        Naast de fysieke en emotionele veranderingen die
                        optreden, kan het ook invloed hebben op je
                        gewichtsverliesdoelen. Veel vrouwen merken namelijk dat
                        het moeilijker is om gewicht te verliezen tijdens hun
                        menstruatie. Maar waarom is dit eigenlijk zo? In deze
                        blogpost zullen we de redenen achter dit fenomeen
                        onderzoeken.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Hormonale schommelingen
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Eén van de belangrijkste redenen waarom het moeilijker
                        is om gewicht te verliezen tijdens de menstruatie zijn
                        hormonale schommelingen. Tijdens deze periode dalen de
                        oestrogeen- en progesteronspiegels in je lichaam, wat
                        kan leiden tot vochtretentie en een opgeblazen gevoel.
                        Dit kan ervoor zorgen dat je tijdelijk meer watergewicht
                        vasthoudt, waardoor het lijkt alsof je niet afvalt
                        ondanks je inspanningen.
                    </p>

                    <p className="mt-4 text-gray-100 break-words">
                        Daarnaast kan de daling van oestrogeen ook invloed
                        hebben op je hongergevoel en eetlust. Sommige vrouwen
                        merken dat ze meer trek hebben in calorierijk voedsel
                        tijdens hun menstruatie, wat het moeilijker maakt om een
                        gezond dieet te volgen. Het is dus belangrijk om bewust
                        te blijven van je voedselinname en te proberen gezonde
                        keuzes te maken, zelfs als je hormonen tegenwerken.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Veranderingen in metabolisme
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Tijdens de menstruatie kan je metabolisme ook vertragen.
                        Dit betekent dat je lichaam minder calorieën verbrandt
                        in rust, waardoor het moeilijker kan zijn om een
                        calorietekort te creëren dat nodig is voor
                        gewichtsverlies. Het is belangrijk om hier rekening mee
                        te houden bij het bepalen van je dagelijkse
                        calorie-inname en fysieke activiteit.
                    </p>

                    <p className="mt-4 text-gray-100 break-words">
                        Een studie gepubliceerd in het tijdschrift "Obstetrics &
                        Gynecology" toonde aan dat vrouwen tijdens de
                        menstruatie gemiddeld 100-300 calorieën per dag minder
                        verbrandden dan tijdens andere fasen van de cyclus. Dit
                        kan over een hele maand oplopen tot aanzienlijke
                        verschillen in energieverbruik.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Emotionele eetbuien
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Voor sommige vrouwen kunnen hormonale schommelingen
                        tijdens de menstruatie ook leiden tot emotionele
                        eetbuien. De bekende 'cravings' naar ongezond voedsel
                        kunnen sterker zijn en moeilijker onder controle te
                        houden zijn. Het is belangrijk om bewust te zijn van
                        deze neiging en manieren te vinden om ermee om te gaan,
                        zoals afleiding zoeken met andere activiteiten of
                        gezondere alternatieven kiezen voor jouw favoriete
                        snacks.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Een studie uitgevoerd door het National Institute of
                        Health (NIH) wees uit dat ongeveer 60% van de vrouwen
                        tijdens hun menstruatie meer trek heeft in voedsel,
                        vooral naar suiker- en vetrijke voeding. Dit kan leiden
                        tot een hogere calorie-inname en het bemoeilijken van
                        gewichtsverlies.
                    </p>
                    {/* -- */}
                    <h2 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl break-words">
                        Conclusie
                    </h2>
                    <p className="mt-4 text-gray-100 break-words">
                        Het is belangrijk om te begrijpen dat gewichtsverlies
                        tijdens de menstruatie moeilijker kan zijn dan op andere
                        momenten in je cyclus. Hormonale schommelingen,
                        veranderingen in metabolisme en emotionele eetbuien
                        kunnen allemaal bijdragen aan dit fenomeen. Het is
                        echter niet onmogelijk om gewicht te verliezen tijdens
                        je menstruatie. Het vereist wellicht wat extra
                        inspanning en bewustzijn van je lichaam en behoeften.
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        Als je merkt dat gewichtsverlies tijdens je menstruatie
                        een uitdaging is, probeer dan geduldig te blijven en
                        focus op het maken van gezonde keuzes. Luister naar je
                        lichaam, pas indien nodig je dieet aan en blijf actief.
                        Uiteindelijk zal het volgen van een gezonde levensstijl
                        resulteren in langdurige resultaten, ongeacht de fase
                        van je cyclus.
                    </p>
                    {/* -- */}
                    <h3 className="text-white mt-8 font-bold uppercase xs:text-3xl sm:text-3xl">
                        Bibliografie
                    </h3>
                    <p className="mt-4 text-gray-100 break-words">
                        "Effect of the menstrual cycle on energy balance" -
                        Obstetrics & Gynecology
                    </p>
                    <p className="mt-4 text-gray-100 break-words">
                        "Changes in food cravings and eating habits across the
                        menstrual cycle" - National Institute of Health (NIH)
                    </p>
                </div>
                <Contact />
            </div>
        </Blog>
    );
};
